import AuthSnackbar from '@/components/common/auth/AuthSnackbar';
import { AnalyticsPage } from '@/types/analytics';
import { Box, useTheme } from '@mui/material';
import { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AnalyticsAppBar from './AnalyticsAppBar';
import AnalyticsLogs from './analyticsLogs/AnalyticsLogs';
import CallList from './callList/CallList';

const BlockEngineAnalytics = () => {
  const theme = useTheme();

  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedPage, setSelectedPage] = useState<AnalyticsPage>();
  const [selectedUUID, setSelectedUUID] = useState<string>('');
  const [selectedRow, setSelectedRow] = useState<GridRowSelectionModel>();

  const handleSelectedPage = (newPage: AnalyticsPage, uuid?: string) => {
    setSelectedPage(newPage);
    uuid && setSelectedRow({ type: 'include', ids: new Set([uuid]) });

    if (newPage === 'Call List') {
      setSelectedUUID('');
      searchParams.delete('uuid');
      searchParams.delete('page');
    } else {
      searchParams.set('page', newPage);
      if (uuid) {
        setSelectedUUID(uuid);
        searchParams.set('uuid', uuid);
      }
    }

    setSearchParams(searchParams);
  };

  useEffect(() => {
    const page = searchParams.get('page');
    const uuid = searchParams.get('uuid');
    uuid && setSelectedUUID(uuid);
    setSelectedPage(page ? (page as AnalyticsPage) : 'Call List');
  }, [searchParams]);

  if (!selectedPage) return <></>;

  return (
    <Box
      sx={{
        color: theme.palette.text.primary,
        bgcolor: theme.palette.background.paper,
        height: '100%'
      }}
    >
      <AnalyticsAppBar page={selectedPage} setPage={(newPage) => handleSelectedPage(newPage)} />
      {selectedPage === 'Call List' ? (
        <CallList
          openLog={(type, newUUID) => handleSelectedPage(type, newUUID)}
          selectedRow={selectedRow}
          setSelectedRow={(newRow) => setSelectedRow(newRow)}
        />
      ) : (
        <AnalyticsLogs
          uuid={selectedUUID}
          selectedPage={selectedPage}
          setSelectedPage={(newPage) => handleSelectedPage(newPage)}
        />
      )}
      <AuthSnackbar message='You are not logged in' position={{ vertical: 'top', horizontal: 'center' }} />
    </Box>
  );
};

export default BlockEngineAnalytics;
